import React, { useEffect } from 'react';
import Toggle from 'common/components/Toggle';
import SortDirectionToggle from './SortDirectionToggle';
import useLotsStore from '../store/useLotsStore';
import useSortStore from '../store/useSortStore';
import useFiltersStore from '../store/useFiltersStore';
import { LotsSortBy } from '../types/filterAndSort';
import settings from '../util/config';
import { getUTCHtmlId } from 'common/util/time';
import usePolygonEventStore from '../store/usePolygonEventStore';
import { usePrintEventStore } from '../store/useMapsStore';
function LotListing({ children, lotListingFilterBarRef, onPrintClick, isMobile }) {
    const { filteredLots } = useLotsStore(["filteredLots"]);
    const { setSortBy } = useSortStore();
    const { quickMoveIn, setQuickMoveIn, setApplyFilterFlag } = useFiltersStore();
    const { isPrintButtonLoading } = usePrintEventStore();
    const { clickedLotId } = usePolygonEventStore(["clickedLotId"]);
    const availableHomesHeadingId = 'available-homes-heading-' + getUTCHtmlId();
    useEffect(() => {
        if (clickedLotId) {
            const ul = document.querySelector('#lot-listing');
            const lotElem = document.querySelector('#lot-' + clickedLotId);
            if (lotElem &&
                ul &&
                (lotElem.getBoundingClientRect().top < ul.getBoundingClientRect().top ||
                    lotElem.getBoundingClientRect().bottom > ul.getBoundingClientRect().bottom)) {
                ul.scrollBy({
                    top: lotElem.getBoundingClientRect().top - ul.offsetHeight,
                    behavior: 'smooth'
                });
            }
        }
    }, [clickedLotId]);
    const handleSortByChange = (selectedOption) => {
        if (selectedOption.target.value === LotsSortBy.Price ||
            selectedOption.target.value === LotsSortBy.DateAdded) {
            setSortBy(selectedOption.target.value);
        }
        else {
            setSortBy(null);
        }
    };
    return (React.createElement("section", { className: "viewport-map__lot-listing-container", "aria-labelledby": availableHomesHeadingId },
        React.createElement("h2", { id: availableHomesHeadingId, className: "sr-only" }, settings.AvailableHomesSectionLabel),
        React.createElement("div", { ref: lotListingFilterBarRef, className: "viewport-map__lot-listing__filters" },
            isMobile && (React.createElement("button", { className: "viewport-map__print-btn cm__loading-spinner", "aria-label": "Print Map", type: "button", "data-spinner-on": isPrintButtonLoading + '', disabled: isPrintButtonLoading, onClick: onPrintClick })),
            React.createElement("p", { className: "viewport-map__lot-listing__lot-count", "aria-live": "assertive" },
                React.createElement("b", { className: "strong" }, filteredLots.length),
                settings.HomesAvailableLabel?.replace('[homes]', '')),
            React.createElement(Toggle, { toggleTitle: settings.QuickMoveInLabel, onChange: (value) => {
                    setQuickMoveIn(value);
                    setApplyFilterFlag(true);
                }, checked: quickMoveIn, renderSmall: true, className: "viewport-map__filters__quick-move-in" }),
            React.createElement("div", { className: "viewport-map__lot-listing__sort-controls" },
                React.createElement("div", { className: "filter-dropdown filter-dropdown--select" },
                    React.createElement("select", { onChange: handleSortByChange, defaultValue: LotsSortBy.Price },
                        React.createElement("option", { value: LotsSortBy.Price }, settings.SortPriceLabel)),
                    React.createElement("i", { className: "filter-dropdown__symbol fas fa-angle-down" })),
                React.createElement(SortDirectionToggle, null))),
        React.createElement("ul", { className: "viewport-map__lot-listing", id: "lot-listing" }, children)));
}
export default LotListing;
export const MemoizedLotListing = React.memo(LotListing);
